import Blockly from "blockly";
import helpers from "blocks/helpers";

Blockly.Blocks.MoveToPose = {
  message0: "move to pose %1",
  args0: [
    {
      type: "input_value",
      name: "pose",
      check: "Pose",
    },
  ],
  previousStatement: "Statement",
  nextStatement: "Statement",
};

Blockly.Blocks.MoveToPose.init = function () {
  this.jsonInit(Blockly.Blocks.MoveToPose);
};

Blockly.JavaScript.MoveToPose = function (block) {
  const pose = helpers.codeForArg("pose", block);

  if (typeof pose === "undefined") {
    return "";
  } else {
    return `visualisation.moveToPose("${pose}", 1);`;
  }
};
